<div class="dashboard-page-root vh-100 d-flex flex-column bg-gray position-fixed top-0 start-0 w-100">

  <!-- Navbar always on top -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100">
  </Navbar>
    <!-- Main area below navbar -->
    <div class="dashboard-main-container container-fluid flex-grow-1">
      <div class="dashboard-main-row row h-100">

        <!-- Sidebar on desktop (with gap below navbar) -->
        <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
          <div class="mt-2">
            <Sidebar ref="sidebar"></Sidebar>
          </div>
        </div>

        <!-- Dashboard content -->
        <div class="dashboard-main-content col bg-white h-100 m-0">
          <div class="dashboard-content-shell m-0 bg-gray h-100">

          <div class="dashboard-content-header d-flex align-items-center justify-content-between flex-wrap gap-2">
            <div>
              <p class="text-uppercase text-primary text-xxs fw-bold mb-1">Workspace</p>
              <h5 class="fw-bold text-dark mb-0">Dashboard Overview</h5>
            </div>
            <span class="fw-bold text-xs d-inline-flex align-items-center gap-1 text-primary">
              <i class="bi bi-activity"></i>
              Live summary
            </span>
          </div>

          <div class="dashboard-stat-scroll">
          <div class="row g-3 dashboard-stat-grid mt-1">
            <!-- Total Portals -->
            <div v-if="client_features.show_portals" class="col-12 col-sm-6 col-xl-3">
              <div class="visitor-card dashboard-stat-card">
                <div class="d-flex align-items-start justify-content-between gap-3">
                  <div class="dashboard-stat-icon bg-primary">
                    <i class="bx bxs-network-chart"></i>
                  </div>
                  <a href="/create_portal" class="dashboard-stat-action" aria-label="View portals">
                    <i class="bi bi-arrow-up-right"></i>
                  </a>
                </div>
                <div class="mt-3">
                  <div class="dashboard-stat-value">{{ total_portals }}</div>
                  <div class="dashboard-stat-label">Total Portals</div>
                </div>
                <div class="dashboard-stat-footer">
                  <div class="d-flex align-items-center gap-2 text-muted">
                    <i class="bi bi-folder2-open"></i>
                    <span>Portal spaces</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Reports (hidden) -->
            <div class="col-12 col-sm-6 col-xl-3 d-none">
              <div class="visitor-card dashboard-stat-card">
                <div class="d-flex align-items-start justify-content-between gap-3">
                  <div class="dashboard-stat-icon dashboard-stat-icon-purple">
                    <i class="bx bxs-report"></i>
                  </div>
                  <a href="/create_portal" class="dashboard-stat-action" aria-label="View reports">
                    <i class="bi bi-arrow-up-right"></i>
                  </a>
                </div>
                <div class="mt-3">
                  <div class="dashboard-stat-value">{{ total_reports }}</div>
                  <div class="dashboard-stat-label">Total Reports</div>
                </div>
                <div class="dashboard-stat-footer">
                  <div class="d-flex align-items-center gap-2 text-muted">
                    <i class="bi bi-file-earmark-text"></i>
                    <span>Published reports</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Events -->
            <div v-if="client_features.show_events" class="col-12 col-sm-6 col-xl-3">
              <div class="visitor-card dashboard-stat-card">
                <div class="d-flex align-items-start justify-content-between gap-3">
                  <div class="dashboard-stat-icon dashboard-stat-icon-success">
                    <i class="bx bxs-calendar-event"></i>
                  </div>
                  <a href="/events" class="dashboard-stat-action" aria-label="View events">
                    <i class="bi bi-arrow-up-right"></i>
                  </a>
                </div>
                <div class="mt-3">
                  <div class="dashboard-stat-value">{{ total_events }}</div>
                  <div class="dashboard-stat-label">Total Events</div>
                </div>
                <div class="dashboard-stat-footer">
                  <div class="d-flex align-items-center gap-2 text-muted">
                    <i class="bi bi-calendar2-week"></i>
                    <span>Scheduled activity</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Groups -->
            <div class="col-12 col-sm-6 col-xl-3 d-none">
              <div class="visitor-card dashboard-stat-card">
                <div class="d-flex align-items-start justify-content-between gap-3">
                  <div class="dashboard-stat-icon dashboard-stat-icon-info">
                    <i class="bx bxs-group"></i>
                  </div>
                  <a href="#" class="dashboard-stat-action" aria-label="View groups">
                    <i class="bi bi-arrow-up-right"></i>
                  </a>
                </div>
                <div class="mt-3">
                  <div class="dashboard-stat-value">0</div>
                  <div class="dashboard-stat-label">Total Groups</div>
                </div>
                <div class="dashboard-stat-footer">
                  <div class="d-flex align-items-center gap-2 text-muted">
                    <i class="bi bi-collection"></i>
                    <span>Community groups</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Users -->
            <div class="col-12 col-sm-6 col-xl-3">
              <div class="visitor-card dashboard-stat-card">
                <div class="d-flex align-items-start justify-content-between gap-3">
                  <div class="dashboard-stat-icon dashboard-stat-icon-info">
                    <i class="bx bxs-user"></i>
                  </div>
                  <a href="/create_user" class="dashboard-stat-action" aria-label="View users">
                    <i class="bi bi-arrow-up-right"></i>
                  </a>
                </div>
                <div class="mt-3">
                  <div class="dashboard-stat-value">{{ total_users }}</div>
                  <div class="dashboard-stat-label">Total Users</div>
                </div>
                <div class="dashboard-stat-footer">
                  <div class="d-flex align-items-center gap-2 text-muted">
                    <i class="bi bi-people"></i>
                    <span>Registered members</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Memberships -->
            <div v-if="client_features.show_memberships" class="col-12 col-sm-6 col-xl-3">
              <div class="visitor-card dashboard-stat-card">
                <div class="d-flex align-items-start justify-content-between gap-3">
                  <div class="dashboard-stat-icon dashboard-stat-icon-warning">
                    <i class="bx bxs-id-card"></i>
                  </div>
                  <a href="/create_membership" class="dashboard-stat-action" aria-label="View memberships">
                    <i class="bi bi-arrow-up-right"></i>
                  </a>
                </div>
                <div class="mt-3">
                  <div class="dashboard-stat-value">{{ total_memberships }}</div>
                  <div class="dashboard-stat-label">Total Memberships</div>
                </div>
                <div class="dashboard-stat-footer">
                  <div class="d-flex align-items-center gap-2 text-muted">
                    <i class="bi bi-patch-check"></i>
                    <span>Membership plans</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Business Profiles -->
            <div v-if="client_features.show_business_profiles" class="col-12 col-sm-6 col-xl-3">
              <div class="visitor-card dashboard-stat-card">
                <div class="d-flex align-items-start justify-content-between gap-3">
                  <div class="dashboard-stat-icon dashboard-stat-icon-purple">
                    <i class="bx bxs-briefcase"></i>
                  </div>
                  <a href="/view_business_dashboard" class="dashboard-stat-action" aria-label="View business profiles">
                    <i class="bi bi-arrow-up-right"></i>
                  </a>
                </div>
                <div class="mt-3">
                  <div class="dashboard-stat-value">{{ total_business_profiles }}</div>
                  <div class="dashboard-stat-label">Total Business Profiles</div>
                </div>
                <div class="dashboard-stat-footer">
                  <div class="d-flex align-items-center gap-2 text-muted">
                    <i class="bi bi-building"></i>
                    <span>Business accounts</span>
                  </div>
                </div>
              </div>
            </div>

            <div  class="col-12 col-sm-6 col-xl-3">
              <div class="visitor-card dashboard-stat-card">
                <div class="d-flex align-items-start justify-content-between gap-3">
                  <div class="dashboard-stat-icon dashboard-stat-icon-warning">
                    <i class="bi bi-heart-pulse"></i>
                  </div>
                  <a
                    href="/donation_campaigns_dashboard"
                    class="dashboard-stat-action border-0 bg-transparent"
                    aria-label="View donation campaigns"
                  >
                    <i class="bi bi-arrow-up-right"></i>
                  </a>
                </div>
                <div class="mt-3">
                  <div class="dashboard-stat-value">{{ total_campaigns }}</div>
                  <div class="dashboard-stat-label">Donation Dashboard</div>
                </div>
                <div class="dashboard-stat-footer">
                  <div class="d-flex align-items-center gap-2 text-muted">
                    <i class="bi bi-graph-up-arrow"></i>
                    <span>Monitor fundraising performance</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Assets -->
            <div v-if="client_features.show_assets" class="col-12 col-sm-6 col-xl-3">
              <div class="visitor-card dashboard-stat-card">
                <div class="d-flex align-items-start justify-content-between gap-3">
                  <div class="dashboard-stat-icon dashboard-stat-icon-success">
                    <i class="bx bxs-folder-open"></i>
                  </div>
                  <a href="/create_assets" class="dashboard-stat-action" aria-label="View assets">
                    <i class="bi bi-arrow-up-right"></i>
                  </a>
                </div>
                <div class="mt-3">
                  <div class="dashboard-stat-value">0</div>
                  <div class="dashboard-stat-label">Total Assets</div>
                </div>
                <div class="dashboard-stat-footer">
                  <div class="d-flex align-items-center gap-2 text-muted">
                    <i class="bi bi-folder2"></i>
                    <span>Stored assets</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Forms -->
            <div class="col-12 col-sm-6 col-xl-3 d-none">
              <div class="visitor-card dashboard-stat-card">
                <div class="d-flex align-items-start justify-content-between gap-3">
                  <div class="dashboard-stat-icon dashboard-stat-icon-warning">
                    <i class="bx bxs-file-blank"></i>
                  </div>
                  <a href="#" class="dashboard-stat-action" aria-label="View forms">
                    <i class="bi bi-arrow-up-right"></i>
                  </a>
                </div>
                <div class="mt-3">
                  <div class="dashboard-stat-value">0</div>
                  <div class="dashboard-stat-label">Total Forms</div>
                </div>
                <div class="dashboard-stat-footer">
                  <div class="d-flex align-items-center gap-2 text-muted">
                    <i class="bi bi-ui-checks"></i>
                    <span>Form templates</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Sections -->
            <div class="col-12 col-sm-6 col-xl-3 d-none">
              <div class="visitor-card dashboard-stat-card">
                <div class="d-flex align-items-start justify-content-between gap-3">
                  <div class="dashboard-stat-icon dashboard-stat-icon-purple">
                    <i class="bx bxs-layout"></i>
                  </div>
                  <a href="#" class="dashboard-stat-action" aria-label="View sections">
                    <i class="bi bi-arrow-up-right"></i>
                  </a>
                </div>
                <div class="mt-3">
                  <div class="dashboard-stat-value">0</div>
                  <div class="dashboard-stat-label">Total Sections</div>
                </div>
                <div class="dashboard-stat-footer">
                  <div class="d-flex align-items-center gap-2 text-muted">
                    <i class="bi bi-layout-three-columns"></i>
                    <span>Form sections</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Questions -->
            <div class="col-12 col-sm-6 col-xl-3 d-none">
              <div class="visitor-card dashboard-stat-card">
                <div class="d-flex align-items-start justify-content-between gap-3">
                  <div class="dashboard-stat-icon dashboard-stat-icon-info">
                    <i class="bx bxs-help-circle"></i>
                  </div>
                  <a href="#" class="dashboard-stat-action" aria-label="View questions">
                    <i class="bi bi-arrow-up-right"></i>
                  </a>
                </div>
                <div class="mt-3">
                  <div class="dashboard-stat-value">0</div>
                  <div class="dashboard-stat-label">Total Questions</div>
                </div>
                <div class="dashboard-stat-footer">
                  <div class="d-flex align-items-center gap-2 text-muted">
                    <i class="bi bi-question-circle"></i>
                    <span>Question bank</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Discussions -->
            <div v-if="client_features.show_your_voice" class="col-12 col-sm-6 col-xl-3">
              <div class="visitor-card dashboard-stat-card">
                <div class="d-flex align-items-start justify-content-between gap-3">
                  <div class="dashboard-stat-icon dashboard-stat-icon-success">
                    <i class="bx bxs-message-dots"></i>
                  </div>
                  <a href="#" class="dashboard-stat-action" aria-label="View discussions">
                    <i class="bi bi-arrow-up-right"></i>
                  </a>
                </div>
                <div class="mt-3">
                  <div class="dashboard-stat-value">0</div>
                  <div class="dashboard-stat-label">Total Discussions</div>
                </div>
                <div class="dashboard-stat-footer">
                  <div class="d-flex align-items-center gap-2 text-muted">
                    <i class="bi bi-chat-dots"></i>
                    <span>Voice activity</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Surveys -->
            <div v-if="client_features.show_your_voice" class="col-12 col-sm-6 col-xl-3">
              <div class="visitor-card dashboard-stat-card">
                <div class="d-flex align-items-start justify-content-between gap-3">
                  <div class="dashboard-stat-icon dashboard-stat-icon-warning">
                    <i class="bx bxs-spreadsheet"></i>
                  </div>
                  <a href="#" class="dashboard-stat-action" aria-label="View surveys">
                    <i class="bi bi-arrow-up-right"></i>
                  </a>
                </div>
                <div class="mt-3">
                  <div class="dashboard-stat-value">0</div>
                  <div class="dashboard-stat-label">Total Surveys</div>
                </div>
                <div class="dashboard-stat-footer">
                  <div class="d-flex align-items-center gap-2 text-muted">
                    <i class="bi bi-clipboard-data"></i>
                    <span>Survey responses</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Polls -->
            <div v-if="client_features.show_your_voice" class="col-12 col-sm-6 col-xl-3">
              <div class="visitor-card dashboard-stat-card">
                <div class="d-flex align-items-start justify-content-between gap-3">
                  <div class="dashboard-stat-icon dashboard-stat-icon-info">
                    <i class="bx bxs-bar-chart-alt-2"></i>
                  </div>
                  <a href="#" class="dashboard-stat-action" aria-label="View polls">
                    <i class="bi bi-arrow-up-right"></i>
                  </a>
                </div>
                <div class="mt-3">
                  <div class="dashboard-stat-value">0</div>
                  <div class="dashboard-stat-label">Total Polls</div>
                </div>
                <div class="dashboard-stat-footer">
                  <div class="d-flex align-items-center gap-2 text-muted">
                    <i class="bi bi-bar-chart"></i>
                    <span>Poll results</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Adverts -->
            <div v-if="client_features.show_ads" class="col-12 col-sm-6 col-xl-3">
              <div class="visitor-card dashboard-stat-card">
                <div class="d-flex align-items-start justify-content-between gap-3">
                  <div class="dashboard-stat-icon dashboard-stat-icon-purple">
                    <i class="bx bxs-megaphone"></i>
                  </div>
                  <a href="#" class="dashboard-stat-action" aria-label="View adverts">
                    <i class="bi bi-arrow-up-right"></i>
                  </a>
                </div>
                <div class="mt-3">
                  <div class="dashboard-stat-value">0</div>
                  <div class="dashboard-stat-label">Total Adverts</div>
                </div>
                <div class="dashboard-stat-footer">
                  <div class="d-flex align-items-center gap-2 text-muted">
                    <i class="bi bi-megaphone"></i>
                    <span>Active placements</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
      </div>
  </div>
</div>
